<template>
  <div>
    <div style="color: #fccc66">
      企业种植面积排名<span style="font-size: 0.7em">（单位：亩）</span>
    </div>
    <dv-capsule-chart :config="config" style="width: 100%; height: 360px" />
  </div>
</template>
<script>
export default {
  data() {
    return {
      config: {
        data: [
          { name: '田峰草莓', value: 365 },
          { name: '艳九天', value: 267 },
          { name: '勤丰果蔬', value: 173 },
          { name: '蝶恋花', value: 155 },
          { name: '上海佳莓', value: 47 },
          { name: '罗塘众鑫', value: 55 },
          { name: '罗塘诚信', value: 45 },
          { name: '罗塘品辰', value: 28 },
        ],
      },
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/screen38496/summary-zone/corp-rank.vue